<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div
        v-show="$route.path == '/Maintain/Recv'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fas fa-wrench"></i>
            </span>
            <h3 class="kt-portlet__head-title">ค้นหาการรับเข้าอะไหล่</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <label>ค้นหาเลขที่ใบงาน/เลขที่ใบเบิกสินค้า:</label>
                  <input v-model="qiKeyword" type="text" class="form-control" placeholder="ค้นหาจาก เลขที่ใบงาน"/>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group ">
                  <label class="label">วันที่สร้าง(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateStart"
                      name="jobsDateStart"
                      ref="jobsDateStart"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">วันที่สร้าง(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateEnd"
                      name="jobsDateEnd"
                      ref="jobsDateEnd"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">ชื่ออะไหล่:</label>
                  <treeselect id="qiProductCode" v-model="qiProductCode" :multiple="true" :options="qiProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label class="label">ผู้ดำเนินการ:</label>
                  <treeselect
                      v-model="qiUserId"
                      :multiple="true"
                      :load-options="LoadUsersIdOptions"
                      :async="true"
                      v-on:open="reLoadUsersIdOptions"
                      v-on:select="ClearAfterselect"
                      placeholder="กรุณาเลือก"
                      :cacheOptions="true"
                      ref="qiUserId"
                    />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Recv/Add"
                  tag="button"
                  title="เพิ่มการรับเข้าอะไหล่"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow('OFFICER_QIMAINTAIN')"
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูลรับเข้าอะไหล่
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped table-bordered table-hover table-checkable"
                id="qiRecvTable" style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all">เลขที่ใบงาน</th>
                    <th class="all">เลขที่ใบเบิกสินค้า</th>
                    <th class="all">จำนวน</th>
                    <th class="all">ชื่ออะไหล่</th>
                    <th class="all">สถานะการดำเนินการ</th>
                    <th class="all">วันที่สร้าง</th>
                    <th class="all">ผู้ดำเนินการ</th>
                    <th class="all">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import datepicker from "../../Shared/Datepicker";
import DatatableWarning from "../../Shared/DatatableWarning";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Action = Vue.extend({
  template: `
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
    <a href="#" @click.prevent="detailQi" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon">
      <i class="fa fa-search"></i>
    </a>
  </div>`,
  methods: {
    detailQi: function() {
      router.push({
        path: `/Maintain/Recv/Detail/${this.data.qiJobId}`,
      });
    },
  },
});

export default {
  components: {
    select2,
    datepicker,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      qiKeyword: null,
      qiProductCode: null,
      qiProductCodeOptions: [],
      qiUserId: [],
      qiUserOptions: [],
      jobsDateStart: null,
      jobsDateEnd: null,
    };
  },
  methods: {
    LoadreProductCodeOptions: function (e) {
      var self = this;
      var qiTypesArray = ['QiSpare'];
      axios
        .post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: qiTypesArray
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductCodeOptions = [];
            data.forEach((element) => {
              self.qiProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    reLoadUsersIdOptions: function(){
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/QIJobs/User/Options",{ 
            page: 1,
            search: searchQuery,
            type: ["JOB_QI_TYPE_PRODUCT_RECEIVE"],
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
    formReset: function(e) {
      this.qiKeyword = null;
      this.qiProductCode = null;
      this.qiUserId = [];
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      $(`#jobsDateStart`).val("").trigger("change");
      $(`#jobsDateEnd`).val("").trigger("change");
      $(`#qiUserId`).val("").trigger("change");
      $(`#qiProductCode`).val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#qiRecvTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#qiRecvTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
  },
  async mounted() {
    let self = this;
    self.LoadreProductCodeOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#qiRecvTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QIJobs/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              SearchKeyword: self.qiKeyword,
              StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
              EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
              QIJobTypeCode: ["JOB_QI_TYPE_PRODUCT_RECEIVE"],
              ProductCode: self.qiProductCode,
              QIJobUsersId: self.qiUserId,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [30, 50, 100],
        pageLength: 30,
        language: {lengthMenu: "Display _MENU_",},

        // Order settings
        order: [[5, "desc"]],
        columns: [
          {
            data: "qiJobNumber",
            className: "text-center",
            render: function(data, type, full, meta) {
              return data ? data : '-';
            },
          },
          {
            data: "refCode",
            className: "text-center",
          },
          {
            data: "amount",
            className: "text-center",
              render: function (data, type, full, meta) {
                  if (!full.sumItems) return '-';

                  return Number(full.sumItems).toLocaleString('en-US');
              },
          },
          {
            data: "materialNameShow",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.items && full.items.length > 0) {
                let displayItems = full.items.slice(0, 2).map(item => {
                  return item.materialName + ' [' + item.materialCode + ']';
                }).join(',<br> ');
                let expandIcon = full.items.length > 2 
                  ? '<a href="/Maintain/Recv/Detail/' + full.qiJobId + '" class="btn btn-link btn-sm px-0 py-0"><i class="fa fa-search"></i></a>' 
                  : '';
                return `${displayItems} ${full.items.length > 2 ? '...' : ''} ${expandIcon}`;
              }
              return data ? data : '-';
            },
          },
          {
            data: "qiStatusName",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (full.qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
                return (
                  '<span><i class="fa fa-check-circle"></i> ' + data + "</span>"
                );
              }
              return data ? data : '-';
            },
          },
          {
            data: "CreatedDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.createdDateFormat;
            },
          },
          { data: "createdUserName", className: "text-center" },
          {
            data: "qiJobId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/QIJob/QIRecvList.vue